import PouchDB from 'pouchdb'
import PouchDBFind from 'pouchdb-find'
PouchDB.plugin(PouchDBFind)

export default {
  db: null,
  init: function (dbName) {
    let promises = []
    this.db = new PouchDB(dbName)

    promises.push(this.db.createIndex({
      index: {fields: ['asset', 'codigo_proyecto', 'action', 'archivado']}
    }))
    promises.push(this.db.createIndex({
      index: {fields: ['asset', 'codigo_proyecto', 'archivar', 'completado', 'solicitado_user']}
    }))
    promises.push(this.db.createIndex({
      index: {fields: ['sync_api']}
    }))

    Promise.all(promises)
  },
  save: function (item, asset, action) {
    item.asset = asset
    item.sync_api = true
    item.action = (item.action ? item.action : action)
    delete item.__v

    if (action === 'create' && !item._id) {
      item._id = Date.now().toString()
    }

    return this.db.put(item)
  },
  findByIds: function (ids, asset) {
    return this.db.find({
      selector: {id: {$in: ids}, asset: asset}
      /* sort: [{id: 'asc'}] */
    })
  },
  findByFilters: function (asset, filters) {
    let _selector = {
      asset: asset
    }

    if (filters.codigo_proyecto) {
      _selector.codigo_proyecto = filters.codigo_proyecto
    }

    if (filters.solicitado_user) {
      _selector.solicitado_user = filters.solicitado_user
    }

    if (filters.archivado) {
      _selector.archivado = filters.archivado
    }

    if (filters.action) {
      _selector.action = filters.action
    }

    if (filters.archivar === true || filters.archivar === false) {
      _selector.archivar = filters.archivar
    }

    if (filters.completado === true || filters.completado === false) {
      _selector.completado = filters.completado
    }

    return this.db.find({
      selector: _selector
      /* sort: [{id: 'asc'}] */
    })
  },
  getById: function (id) {
    return this.db.get(id)
  },
  getAllToSync: function () {
    return this.db.find({
      selector: {sync_api: true}
    })
  },
  remove: function (item) {
    return this.db.remove(item)
  }

}



// WEBPACK FOOTER //
// ./src/core/pouchdb.js